import { mapState } from "../store/map";
import { computed } from "vue";
export default {
  name: "KilaKilaAdminCard",
  setup: function setup() {
    var _mapState = mapState("adminAbout"),
        adminInfo = _mapState.adminInfo,
        articleCountInfo = _mapState.articleCountInfo;

    function gotoGithub() {
      location.href = adminInfo.value.githubUrl;
    }

    return {
      adminInfo: adminInfo,
      articleCountInfo: articleCountInfo,
      gotoGithub: gotoGithub,
      computed: computed
    };
  }
};